import { render, staticRenderFns } from "./BaseStep.vue?vue&type=template&id=6cd54254"
import script from "./BaseStep.vue?vue&type=script&lang=js"
export * from "./BaseStep.vue?vue&type=script&lang=js"
import style0 from "./BaseStep.vue?vue&type=style&index=0&id=6cd54254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports